import { getEmulationSession } from '../contexts/EmulationContext';

/**
 * The origin to stamp on a link this app generates for someone ELSE — a public
 * form URL, a careers page, a kiosk pairing link, an external-portal address, a
 * website embed snippet.
 *
 * Normally that is simply the origin the user is browsing: a tenant's members
 * work on their own workspace host. The exception is sysadmin emulation. The
 * emulation JWT is origin-bound (see EmulationContext), so the sysadmin's browser
 * stays on the sysadmin console for the whole session while every action they
 * take belongs to the emulated tenant — and `window.location.origin` hands out
 * links on a host the recipient cannot even sign in to. The backend fixes its own
 * generated URLs through the emulation token's `frontend_origin` claim; this is
 * the same resolution for links the SPA builds, carried on the emulation session
 * as `workspace_origin`.
 *
 * A null `workspace_origin` means "the current origin is already correct" — a
 * single-host deployment (local dev), or a session started before this field
 * existed.
 *
 * Not for same-app navigation, API calls or OAuth redirects: those must stay on
 * the host holding the session. Use `window.location.origin` /
 * `getMainDomainOrigin()` for those.
 */
export function getWorkspaceOrigin(): string {
  return getEmulationSession()?.workspace_origin || window.location.origin;
}
